import React from "react";
import { Typography } from "@mui/material";
import {
  StyledContainer,
  PageTitle,
  ContentSection,
  StyledList,
  InfoBox,
  textStyles,
} from "../../components/common/StyledComponents";

const PelerinajMoldova = () => {
  return (
    <StyledContainer>
      <PageTitle>Pelerinaj în Republica Moldova</PageTitle>

      <ContentSection title="Cuvânt de început">
        <Typography sx={{ ...textStyles.bold, color: "#2e7d32", mb: 2 }}>
          🌿„Iată acum ce este bun și ce este frumos, decât numai a locui frații
          împreună!" (Psalmul 132, 1)
        </Typography>
        <Typography sx={textStyles.regular}>
          ⚜️ Agenția Pelerinul Creștin cu binecuvântarea Preasfințitului Părinte
          IUSTIN, desfășoară în perioada
          <strong> 13–17 august 2025</strong>, un pelerinaj în Republica Moldova
          – meleag binecuvântat, pământ de credință, istorie și inimă
          românească, o călătorie a sufletului și a neamului.
        </Typography>
        <Typography sx={textStyles.regular} mt={2}>
          ⚜️ Republica Moldova nu este doar un ținut de rugăciune, ci și un
          spațiu sacru al memoriei istorice. Fiecare biserică veche este o
          mărturie vie a unei credințe neînfrânte.
        </Typography>
      </ContentSection>

      <ContentSection title="Popasuri Duhovnicești">
        <Typography sx={textStyles.regular}>
          ⚜️ Vom vizita locuri de mare încărcătură spirituală și culturală:
        </Typography>
        <StyledList>
          <li>⛪ Mănăstirea Vărzărești</li>
          <li>⛪ Mănăstirea Hâncu</li>
          <li>⛪ Mănăstirea Căpriana</li>
          <li>⛪ Mănăstirea Condrița</li>
          <li>⛪ Mănăstirea Suruceni</li>
          <li>⛪ Mănăstirea Butuceni (săpată în piatră)</li>
          <li>⛪ Mănăstirea Țigănești</li>
          <li>⛪ Mănăstirea Hîrjauca</li>
          <li>⛪ Mănăstirea Frumoasa</li>
          <li>⛪ Catedrala Mitropolitană din Chișinău</li>
          <li>🍇 Vizită specială la cramele Cricova</li>
        </StyledList>
      </ContentSection>

      <ContentSection title="Servicii Incluse">
        <StyledList>
          <li>✨ 3 nopți cazare</li>
          <li>✨ 1 masă/zi</li>
          <li>✨ Transport cu autocar</li>
          <li>✨ Preot însoțitor</li>
          <li>✨ Ghidaj religios</li>
          <li>✨ Alte bucurii duhovnicești</li>
        </StyledList>
      </ContentSection>

      <ContentSection title="Informații de Călătorie">
        <InfoBox>
          <Typography sx={textStyles.regular}>⚜️ Preț: 1500 LEI</Typography>
          <Typography sx={textStyles.regular}>
            ⚜️ Plecare: miercuri, 13 august, ora 18:00, de la Catedrala
            Episcopală „Sfânta Treime” – Baia Mare
          </Typography>
          <Typography sx={textStyles.regular}>
            🙏 Grupul va fi însoțit de părintele consilier Valeriu Vana
          </Typography>
        </InfoBox>
      </ContentSection>

      <ContentSection title="Înscrieri și Contact">
        <Typography sx={textStyles.regular}>
          📝 Înscrieri și informații: Telefon: 0755 182 802
        </Typography>
        <Typography sx={textStyles.regular}>
          📝 Facebook: Agenția Pelerinul Creștin
        </Typography>
        <Typography sx={textStyles.regular}>
          📝 Website: www.pelerinulcrestin.ro
        </Typography>
        <Typography sx={textStyles.regular}>
          📝 Confirmarea locului se face prin achitarea unui avans în maxim 5
          zile de la înscriere
        </Typography>
        <Typography sx={textStyles.regular}>
          📝 Pentru o bună desfășurare a pelerinajului, grupul va fi format din
          minimum 30 persoane
        </Typography>
      </ContentSection>

      <Typography sx={{ ...textStyles.bold, mt: 4, textAlign: "center" }}>
        ⚜️ Slavă și mulțumire Domnului pentru toate!
      </Typography>
    </StyledContainer>
  );
};

export default PelerinajMoldova;
